import type { IOrganizationExchangeEMail } from './OrganizationExchangeEMail.interface';

export default class OrganizationExchangeEMail implements IOrganizationExchangeEMail {
  address: string;
  replyTo: string;
  bcc: string;
  footerInformation: string;

  static build = (data: IOrganizationExchangeEMail) => new OrganizationExchangeEMail(data);
  static blank = () => new OrganizationExchangeEMail();

  /**
   * Constructor
   * @param {IOrganizationExchangeEMail} data
   */
  constructor(data?: IOrganizationExchangeEMail) {
    this.address = data?.address || undefined;
    this.replyTo = data?.replyTo || undefined;
    this.bcc = data?.bcc || undefined;
    this.footerInformation = data?.footerInformation || undefined;
  }
}
